import { createAction, props } from "@ngrx/store";
import { StatusIntegracao } from "@shared/models/status-integracao/status-integracao.model";

export const updateStatusIntegracoes = createAction(
    '[StatusIntegracoes] Update Status Integracoes',
    props<{statusIntegracoes: StatusIntegracao[]}>()
)